// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import VitaloraIntegrations from "./view";

import PendingComponent from "../../components/PendingComponent";
import { isDemoEnterprise } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";

export const vitaloraIntegrationsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "integrations",
  beforeLoad() {
    if (!isDemoEnterprise()) {
      throw redirect({ to: "/" });
    }
  },
  component: VitaloraIntegrations,
  pendingComponent: PendingComponent,
});
